export function taglineFor(element: JSX.Element, index: number): JSX.Element {
  return <div className="tagline" key={`tagline-${index}`}>{element}</div>
}